const updates = [
  {
    date: '2026-07-31',
    title: 'V5.2.1版本发布：播放引擎全面升级',
    desc: '新版APP采用全新解码内核，4K视频加载速度提升40%，支持HDR10+显示，电池续航优化延长30%。',
    tag: '版本更新',
  },
  {
    date: '2026-07-28',
    title: '暑期档专题「炎夏观影季」正式上线',
    desc: '精选100部暑期热门电影和剧集，涵盖动作、喜剧、动画等全品类，每日推荐一部高分佳作。',
    tag: '专题上线',
  },
  {
    date: '2026-07-25',
    title: '新增「AI智能推荐」功能',
    desc: '基于深度学习算法分析你的观影偏好，为你精准推荐符合口味的影视内容，越用越懂你。',
    tag: '新功能',
  },
  {
    date: '2026-07-20',
    title: '片库扩容：新增3000+小时内容',
    desc: '与多家内容方达成合作，一次性引入3000+小时正版影视资源，涵盖经典老片和海外热门剧集。',
    tag: '内容更新',
  },
  {
    date: '2026-07-15',
    title: '下载功能升级：支持后台批量下载',
    desc: '用户现在可以一次性选择多部影片加入下载队列，APP将在后台自动完成下载，无需保持前台。',
    tag: '功能优化',
  },
  {
    date: '2026-07-10',
    title: '用户安全加固：通过权威安全检测',
    desc: '91精品影视APP通过多家第三方安全机构检测认证，获得「绿色安全应用」标识，用户可放心使用。',
    tag: '安全公告',
  },
  {
    date: '2026-07-05',
    title: '七月片单发布：多部独家内容上线',
    desc: '本月将有5部独家首播剧集和3部院线同步电影登陆平台，内容储备充足，精彩不断档。',
    tag: '片单发布',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-white">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            版本更新、内容上线、功能迭代一手掌握
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((u, i) => (
            <div key={i} className="relative flex gap-4 pb-8 last:pb-0">
              {i < updates.length - 1 && (
                <div className="absolute left-[19px] top-10 bottom-0 w-px bg-secondary-200"></div>
              )}
              <div className="relative z-10 flex-shrink-0 w-[38px] h-[38px] rounded-full bg-primary-100 border-2 border-primary-200 flex items-center justify-center">
                <i className="ri-flashlight-line text-primary-600 text-sm"></i>
              </div>
              <div className="flex-1 pt-1">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{u.date}</span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">{u.tag}</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">{u.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{u.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}